var $a10a0369f5433ed1$exports = {};
$a10a0369f5433ed1$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " mulighed tilg\xE6ngelig");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " muligheder tilg\xE6ngelige");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Angivet gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " mulighed");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " muligheder");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valgt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Forslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valgt");
  }
};
export { $a10a0369f5433ed1$exports as default };